module.exports = __webpack_public_path__ + "img/ic_plus_with_box.3bb6f2cc.svg";